import React from 'react'
import MapitShipOrderForm from '../MapitShipOrderForm'

export default function AddOrderSection({
    tempOrder,
    handleOrderChange,
    validationErrors
}) {
    return (
        <MapitShipOrderForm
            tempOrder={tempOrder}
            handleOrderChange={handleOrderChange}
            coordinates={tempOrder?.user?.location?.coordinates}
            validationErrors={validationErrors}
        />
    )
}
